import { useCallback } from 'react';
import MunicipalPortalAAppService from 'application/platform/municipal-portal-service';
import { useOrganizationalStructureDispatch } from './organizational-structure-context';
import { ACTION_TYPES } from './organizational-structure-reducer';

export const useOrganizationalStructureController = () => {
  const dispatch = useOrganizationalStructureDispatch();

  const onInit = useCallback(async () => {
    await listGovernamentalStructures();
  }, []);

  const listGovernamentalStructures = useCallback(async () => {
    try {
      dispatch({ type: ACTION_TYPES.setLoading, payload: true });
      
      const response = await MunicipalPortalAAppService.listGovernamentalSctructure();
      
      dispatch({ type: ACTION_TYPES.setGovernamentalStructures, payload: response });
    } catch (error) {
      console.error('Error loading governmental structures:', error);
      dispatch({ type: ACTION_TYPES.setGovernamentalStructures, payload: [] });
    } finally {
      dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }
  }, [dispatch]);

  return {
    onInit,
    listGovernamentalStructures,
  };
};